import React from 'react'
import DashboardCard from './DashboardCard'

interface Props {
  members: number
}

export default function MembersCard({ members }: Props) {
  return (
    <DashboardCard
      to="/members"
      gradient="linear-gradient(135deg, #3b1f5e 0%, #251040 60%, #4a2875 100%)"
      accentColor="#d4a3ff"
      badgeIcon="bi-people-fill"
      badgeLabel="QUADRO SOCIAL"
      title="SÓCIOS CADASTRADOS"
      watermarkIcon="bi-people"
      topRightIcon="bi-people-fill"
      metaLabel="TOTAL DE SÓCIOS"
      value={members || '0'}
      valueSuffix={`sócio${members !== 1 ? 's' : ''}`}
    />
  )
}
